import { createContext, useContext } from "react";
import { KnowledgeHubConfig } from "../../pages/knowledge-hub/index.types";
import { KnowledgeHubPage } from "../../pages/knowledge-hub";
import {
  KnowledgeHubContextType,
  UseKnowledgeHubReturn,
} from "./useKnowledgeHub.types";

export const useKnowledgeHub = (): UseKnowledgeHubReturn => {
  const context = useContext(KnowledgeHubContext);
  if (!context) {
    throw new Error(
      "useKnowledgeHub must be used within a KnowledgeHubProvider"
    );
  }

  const { config, loadingConfig, configurationToken } = context;

  return {
    config,
    loadingConfig,
    configurationToken,
  };
};

const KnowledgeHubContext = createContext<KnowledgeHubContextType | undefined>(
  undefined
);

export const KnowledgeHub = ({
  config,
  loadingConfig,
  configurationToken,
}: {
  config: KnowledgeHubConfig | null;
  loadingConfig: boolean;
  configurationToken: string;
}) => {
  return (
    <KnowledgeHubContext.Provider
      value={{
        config,
        loadingConfig,
        configurationToken,
      }}
    >
      <KnowledgeHubPage configurationToken={configurationToken} />
    </KnowledgeHubContext.Provider>
  );
};
